<template lang="pug">
 #deleteBusiness
  .container.text-center
    b-icon(icon="x-circle" style="width: 80px; height: 80px; margin-bottom: 20px;" variant="danger")
    h2 ¿Estás Seguro?
    p Seguro que desea eliminar la empresa {{selectedBusiness.name}}
    p IMPORTANTE: También se eliminarán los clientes y archivos de la empresa
  .modal-footer
    b-button(@click="hideModal", variant="outline-muted") Cancelar
    b-button(@click="confirmDelete", variant="danger") Eliminar
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: ["selectedBusiness", "hideModal", "makeToast"],
  methods: {
    ...mapActions(['deleteBusiness']),
    async confirmDelete() {
      const response = await this.deleteBusiness(this.selectedBusiness.id);
      if (response.status === 200) {
        this.makeToast('success', response.data.message, "Empresa eliminada!");
        this.hideModal()
      } else {
        this.makeToast('danger', response.data, "Ocurrió un error!");
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#deleteBusiness {
  .modal-footer {
    padding: 0;
  }
  .modalButton {
    margin-right: 10px;
  }  
}
</style>